// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c3cb1788","56":"0fc0d78b","200":"5bff863b","453":"87436aa7","720":"61ee77e6","894":"026b4b57","965":"37ead4d6"}[chunkId] + ".chunk.js";
};